import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles, Tooltip, Typography, Button } from '@material-ui/core/';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import ManageAssetInNewTabLink from '../ManageAsset/ManageAssetInNewTabLink';
import OpenInNew from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles((theme) => ({
	productName: {
		width: '32rem',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		'&:hover': { cursor: 'help' },
	},
	subtitle: {
		color: theme.palette.neutral.n400,
		textTransform: 'uppercase',
	},
}));

const LinkedAsset = ({ asset }) => {
	// Avoid linked asset button for unlinked products.
	if (asset) {
		return (
			<Tooltip title="view asset details" arrow={true} placement="top">
				<span>
					<ManageAssetInNewTabLink
						assetUUID={asset.id}
						linkTxt="Linked Asset"
						icon={<OpenInNew color="primary" />}
					></ManageAssetInNewTabLink>
				</span>
			</Tooltip>
		);
	}
	return null;
};

const ProductValueWithCopyIcon = ({value}) => {
	const copyIconTooltip = 'Click to copy to the clipboard.';
	return (
		<Tooltip title={copyIconTooltip} arrow={true} placement="top">
			<Button
				style={{ fontSize: '1rem', cursor: 'copy' }}
				color="inherit"
				startIcon={<CopyIcon />}
				onClick={() => {
					navigator.clipboard.writeText(value);
				}}
			>
				{value}
			</Button>
		</Tooltip>
	);
}

export default function ProductInfo({ avatar, download, id, name, overflow, type, asset }) {
	const classes = useStyles();
	return (
		<Grid container item spacing={2}>
			<Grid item>{avatar}</Grid>
			<Grid item>
				<Grid container direction="column" spacing={1}>
					<Grid item>
						<Typography className={classes.subtitle} variant="subtitle1">
							{type}
						</Typography>
					</Grid>
					<Grid container item alignItems="center" spacing={1}>
						<Grid item>
							<Tooltip title={name} arrow={true} placement="top">
								<Typography className={classes.productName} variant="h4">
									{name}
								</Typography>
							</Tooltip>
						</Grid>
						<Grid item>{download}</Grid>
						<Grid item>
							<LinkedAsset asset={asset} />
						</Grid>
					</Grid>
					<Grid item>
						<Typography color="textSecondary" variant="body2">
							{'CORGIS ID: '}
							<ProductValueWithCopyIcon value={id} />
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

ProductInfo.propTypes = {
	avatar: PropTypes.element.isRequired,
	id: PropTypes.string.isRequired,
	download: PropTypes.element.isRequired,
	name: PropTypes.element.isRequired,
	overflow: PropTypes.element,
	type: PropTypes.string,
};
ProductInfo.defaultProps = { type: 'Product' };
